/**
 * Scheduled-maintenance detection (OS cutover window).
 *
 * During the window studio-trpc refuses every MUTATION with 503 while reads
 * keep working (truman/docs/MAINTENANCE-MODE.md). A bare 503 is not enough to
 * key off — the /api/trpc proxy returns its own 503 when misconfigured — so the
 * signal is the header truman's adapter sets, with the `maintenance: true`
 * field of the tRPC error shape as a fallback when the header is missing.
 *
 * Pure on purpose: no React, no toast, so it is testable without a network.
 * Mirrors apps/inbox-web/src/state/maintenance.ts.
 */

/** Set by truman's tRPC adapter. Lower-cased for `Headers.get`. */
export const MAINTENANCE_HEADER = "x-trackstack-maintenance";

/** Field truman's errorFormatter adds to `error.data` on the refusal. */
const MAINTENANCE_BODY_MARKER = '"maintenance":true';

export type MaintenanceResponseLike = {
  status: number;
  headers: { get: (name: string) => string | null };
};

/**
 * Is this response the maintenance refusal? Pass `bodyText` only when the
 * header is missing, since reading a body consumes it.
 */
export const isMaintenanceResponse = (
  response: MaintenanceResponseLike,
  bodyText?: string,
): boolean => {
  if (response.status !== 503) return false;
  if (response.headers.get(MAINTENANCE_HEADER) === "1") return true;
  return Boolean(bodyText?.includes(MAINTENANCE_BODY_MARKER));
};

export const MAINTENANCE_TOAST_ID = "trackstack-maintenance";

export const MAINTENANCE_TOAST_TITLE = "Trackstack is being upgraded";

export const MAINTENANCE_TOAST_DESCRIPTION =
  "Posting and other changes are paused for a few hours. Everything you can see is still here. Please try again later.";
